import PropTypes from 'prop-types';
import React from 'react';
import { AdditionalInformationCardCss } from './AdditionalInformationCard.styles';

const AdditionalInformationCard = ({ headerText, children, headerType }) => {
  return (
    <section className="container">
      <div className={headerType}>
        <span>{headerText}</span>
      </div>
      <div className="bodyContainer">{children}</div>
      <style jsx>{AdditionalInformationCardCss}</style>
    </section>
  );
};

AdditionalInformationCard.propTypes = {
  headerText: PropTypes.string.isRequired,
  children: PropTypes.object.isRequired,
  headerType: PropTypes.oneOf(['headerContainer', 'mkp-headerContainer', '']),
};

AdditionalInformationCard.defaultProps = {
  headerType: 'headerContainer',
};

export { AdditionalInformationCard };
